var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.withLink)?_c('a',{key:"withLink",staticClass:"phone-number-display-link",attrs:{"href":_vm.formatURI}},[_vm._v(_vm._s(_vm.formatHuman))]):_c('span',{key:"noLink",staticClass:"phone-number-display"},[_vm._v(_vm._s(_vm.formatHuman))])])
}
var staticRenderFns = []

export { render, staticRenderFns }